import Heading from './components/Heading';

export default Heading;
